import { createContext, useContext } from 'react';

// Dialog.tsx
type FooterContextType = {
  historyOpen: boolean;
  setHistoryOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const FooterContext = createContext<FooterContextType | null>(null);

export const useFooterContext = () => {
  const context = useContext(FooterContext);

  if (!context) {
    throw new Error('Only should be used on the Footer scope');
  }

  return context;
};

export const { Provider: FooterProvider } = FooterContext;
